import { zodResolver } from "@hookform/resolvers/zod";
import { useForm, type FieldValues, type UseFormProps } from "react-hook-form";
import { type input, type output, type ZodType } from "zod";

interface UseZodFormProps<
  TSchema extends ZodType<FieldValues, FieldValues>,
  TContext = any,
> extends Omit<UseFormProps<input<TSchema>, TContext>, "resolver"> {
  schema: TSchema;
}

export const useZodForm = <
  Z extends ZodType<FieldValues, FieldValues>,
  TContext = any,
>({
  schema,
  ...formProps
}: UseZodFormProps<Z, TContext>) => {
  return useForm<input<Z>, TContext, output<Z>>({
    resolver: zodResolver(schema) as any,
    ...(formProps as Omit<
      UseFormProps<input<Z>, TContext>,
      "resolver" | "formControl"
    >),
  });
};
